import React from 'react';
import PropTypes from 'prop-types';

import {injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import CustomSwitch from "components/switch/CustomSwitch";

import getNestedValue from "utils/getNestedValue";

SwitchTypeField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    checked: PropTypes.bool
};

function SwitchTypeField({name, label, required = false, disabled = false, checked = false, ...props}) {
    const {values, setFieldValue} = useFormikContext();

    return (
        <CustomSwitch
            disabled={disabled}
            required={required}
            checked={getNestedValue(values, name) ?? checked}
            onClick={(event) => setFieldValue(name, event.target.checked)}
            label={props.intl.formatMessage({id: label})}
        />
    );
}

export default injectIntl(SwitchTypeField);
